import makeList from './makeList.js'

let viewFloor = '管理棟3F'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '管理棟３階階段室',
        file: './data/I18d_3.JPG',
        rotation: -38.110577688802024,
        link: [
          {
            file: './data/I18c_2.JPG',
            position: [ 3691.5691153132125, -3145.687791830687, 1200.9736266816212 ],
          },
          {
            file: './data/I18k.JPG',
            position: [ 3184.8283839294513, 888.6347130649651, -3739.6431192747464 ],
          },
          {
            file: './data/I18e_3.JPG',
            position: [ -4580.8147135727595, 1119.428090452738, 1641.1128950940272 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 516.7037861915368, 203.86859688196 ],
        },
      },
      { description: '管理棟３階廊下',
        file: './data/I18e_3.JPG',
        rotation: 43.80345750225393,
        link: [
          {
            file: './data/I18d_3.JPG',
            position: [ 490.94876624783427, -27.78955280648187, -4973.178504253465 ],
          },
          {
            file: './data/I18o.JPG',
            position: [ -1610.6031480082129, 117.2935620998253, -4725.202943843692 ],
          },
          {
            file: './data/I18x.JPG',
            position: [ -3347.721099653055, 41.943149854086904, -3711.3287420901843 ],
          },
          {
            file: './data/I18s.JPG',
            position: [ 1461.2867149923172, 32.54628401989521, 4776.414318358506 ],
          },
          {
            file: './data/I18q.JPG',
            position: [ 396.43447073334124, 43.81238055716983, 4977.502252931545 ],
          },
          {
            file: './data/I18sa.JPG',
            position: [ -1091.3431238954074, 120.24277713156297, 4871.977913740434 ],
          },
          {
            file: './data/I18j.JPG',
            position: [ -4983.184776662483, -390.6499003859263, -27.979154008067507 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 570.1559020044543, 252.86636971046778 ],
        },
      },
      { description: '食堂',
        file: './data/I18k.JPG',
        rotation: -49.96915788746145,
        link: [
          {
            file: './data/I18y.JPG',
            position: [ 3528.7927746528053, 293.05905165709265, -3516.3230639730405 ],
          },
          {
            file: './data/I18p.JPG',
            position: [ -4961.594352045342, 184.35927016585197, -545.9490208477653 ],
          },
          {
            file: './data/I18d_3.JPG',
            position: [ -4369.037814215786, 551.3702553088099, 2348.3143692438343 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 445.43429844097994, 170.46102449888656 ],
        },
      },
      { description: 'サロン',
        file: './data/I18y.JPG',
        rotation: -187.17319888178142,
        link: [
          {
            file: './data/I18k.JPG',
            position: [ -4743.438922860476, 1042.370159787, 1152.0710404270194 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 400.89086859688194, 143.73496659242767 ],
        },
      },
      { description: '厨房(手前)',
        file: './data/I18p.JPG',
        rotation: 81.45058090240347,
        link: [
          {
            file: './data/I18o.JPG',
            position: [ -4804.571522467514, -67.40331648015561, 1350.9178467071613 ],
          },
          {
            file: './data/I18k.JPG',
            position: [ 4940.441984105712, 238.5375430325005, 665.9112189105213 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 563.4743875278397, 148.18930957683756 ],
        },
      },
      { description: '厨房(奥)',
        file: './data/I18o.JPG',
        rotation: 112.38518743503776,
        link: [
          {
            file: './data/I18p.JPG',
            position: [ 2830.6857202848455, 53.759174187686405, -4112.862099658092 ],
          },
          {
            file: './data/I18e_3.JPG',
            position: [ 2570.967731733585, 813.1435729318487, 4203.405197895244 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 619.1536748329621, 166.00668151447667 ],
        },
      },
      { description: '通信室(手前)',
        file: './data/I18s.JPG',
        rotation: -34.45442784305827,
        link: [
          {
            file: './data/I18e_3.JPG',
            position: [ -4876.06706048296, 56.65240375378093, 1085.7223435118174 ],
          },
          {
            file: './data/I18r.JPG',
            position: [ 2898.1339272712366, 218.65413743520628, 4061.3462691588556 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 429.84409799554567, 277.36525612472167 ],
        },
      },
      { description: '通信室(奥)',
        file: './data/I18r.JPG',
        rotation: 138.8591840171273,
        link: [
          {
            file: './data/I18s.JPG',
            position: [ -1758.4764859774098, 735.8422796236997, -4613.3874909243505 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 371.9376391982183, 301.86414253897567 ],
        },
      },
      { description: '隊長室',
        file: './data/I18q.JPG',
        rotation: 134.76064873084218,
        link: [
          {
            file: './data/I18e_3.JPG',
            position: [ -789.1807728097206, 395.7368408390455, -4914.398188333216 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 512.2494432071269, 319.6815144766148 ],
        },
      },
      { description: '庶務室書庫',
        file: './data/I18j.JPG',
        rotation: 64.75315388534341,
        link: [
          {
            file: './data/I18e_3.JPG',
            position: [ 4036.418300060029, 1165.7146707844686, -2699.515808221781 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 625.8351893095768, 297.4097995545659 ],
        },
      },
      { description: '印刷室',
        file: './data/I18x.JPG',
        rotation: -61.705154737802154,
        link: [
          {
            file: './data/I18e_3.JPG',
            position: [ 4718.456148777491, 897.5289601107365, -1356.471785919029 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 672.6057906458797, 257.32071269487756 ],
        },
      },
      { description: '庶務室',
        file: './data/I18i.JPG',
        rotation: 90.42512769619027,
        link: [
          {
            file: './data/I18j.JPG',
            position: [ 2785.280939513969, -209.75314912150608, -4135.050330763526 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 670.3786191536748, 348.63474387527856 ],
        },
      },
      { description: '公衆電話室',
        file: './data/I18sa.JPG',
        rotation: 120.09669107717454,
        link: [
          {
            file: './data/I18e_3.JPG',
            position: [ 2186.159994288767, -6.858543686368854, -4489.734293477734 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 565.7015590200446, 324.13585746102456 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
